import fetch from 'isomorphic-fetch';
import {
    API2_URL,
    PROJECTS_REQUEST,
    PROJECTS_EDIT,
    PROJECTS_FETCH,
    PROJECTS_LIST,
    PROJECTS_FAIL,
    /*PROJECT_SET_SEARCH,*/
    PROJECTS_CLEAR,
    PROJECTS_COMPLETE,
    PROJECTS_GOALS,
    PROJECTS_EXPENSES,
    PROJECTS_PHASES_GROUPS,
    PROJECTS_PHASES_GROUPS_EDIT,
    PROJECTS_EMPLOYEES,
    PROJECTS_EMPLOYEES_EDIT,
    PROJECTS_EDIT_REQUEST,
    PROJECTS_COMMISSIONS,
    PROJECTS_FOLIOS
} from "../store/config";
import { newNotification } from "./notifications";
import _ from "lodash";
import { sessionService } from 'redux-react-session';
import { statusGroupList } from "./status";
import { modalitiesList } from "./modalities";
import { versionsList } from "./versions";
import { entitiesList } from "./entities";
import { municipalitiesList } from "./municipalities";
import { goalsList } from "./goals";
import { actorsList } from "./directories";
import { conagoList } from "./directories";
import { resourceConceptsList } from "./resource_concept";
import { conceptsList } from "./concepts";
import { history } from "../store/store";
import FileSaver from "file-saver";


/* Projects Show*/
export const fetchProjects = (page = 1, filters = {}) => {
    return dispatch => {
        return dispatch(sessionService.loadUser)
            .then(sess => {
                dispatch(projectsRequest());

                const options = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sess.profile.access_token}`
                    },
                    method: 'get'
                };

                let params = '';
                _.mapKeys(filters, (value, key) => {
                    if (value) {
                        params = `${params}&${key}=${value}`;
                    }
                });

                return fetch(`${API2_URL}/projects/projects?page=${page}&include[0]=modality&include[1]=agency.agenciable&include[2]=amounts${params}`, options)
                    .then(result => {
                        if (result.status >= 200 && result.status < 300) {
                            return result.json();
                        } else {
                            return result.json().then(Promise.reject.bind(Promise));
                        }
                    })
                    .then(
                        json => {
                            return dispatch(projectsData(json))
                        },
                        error => {
                            dispatch(newNotification({ title: '¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: 'danger' }));
                            return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                        }
                    )
            })
    }
};

/* Projects Export*/
export const projectsExport = (filters = {}, optionsExport = []) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            dispatch(projectsRequest());

            const options = {
                headers: {
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'get'
            };

            let params = '';
            let include_exports = '';
            _.mapKeys(filters, (value, key) => {
                if (value) {
                    params = `${params}&${key}=${value}`;
                }
            });

            _.mapKeys(optionsExport, (value, key) => {
                if (value) {
                    include_exports = `${include_exports}&include_export[${key}]=${value}`;
                }
            });

            let fileName = undefined;

            return fetch(`${API2_URL}/projects/projects?include[0]=modality&include[1]=agency.agenciable&include[2]=amounts${params}&export=1${include_exports}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        let header = result.headers.get('Content-Disposition', 'attachment')
                        fileName = header.match(/filename="(.+)"/)[1];
                        return result.blob();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    blob => {
                        //let today = new Date();
                        //let date = today.getFullYear() + ((today.getMonth() + 1) <10 ? `0${today.getMonth() + 1}`:today.getMonth() + 1) + (today.getDate()<10 ? `0${today.getDate()}`:today.getDate()) + today.getHours() + today.getMinutes() + today.getSeconds();
                        //FileSaver.saveAs(blob,`reporte_usuarios_${date}.xls`);
                        FileSaver.saveAs(blob, fileName);
                        dispatch(projectsComplete());
                    },
                    error => {
                        dispatch(newNotification({ title: '¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error), type: 'danger' }));
                        return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
                    }
                )
        })
};

export const fetchProjectsList = (value = undefined) => (dispatch) => {
        return dispatch(sessionService.loadUser)
            .then(sess => {
                    dispatch(projectsRequest());

                    const options = {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${sess.profile.access_token}`
                        },
                        method: 'get'
                    };


                    return fetch(`${API2_URL}/projects/projects?include[0]=status&include[agency][0]=agenciable&include[agency][1]=owner${value ? `&version_id=${value}`:''}&per_page=all` , options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectsListData(json)),
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
};

const projectsData = (json) => {
	return {
		type: PROJECTS_FETCH,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		timestamp: Date.now()
	};
};

const projectsListData = (json) => {
	return {
		type: PROJECTS_LIST,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	};
};
/*
const projectsSetSearch = (q) => {
	return {
		type: PROJECT_SET_SEARCH,
		search: q,
		timestamp: Date.now()
	}
}*/

export const fetchProjectEdit = (id = undefined) => (dispatch) => {
	dispatch(projectsRequest());
	dispatch(projectsClear());

	return dispatch(statusGroupList())
		.then((status) => {
			if(!_.isEmpty(status.payload)){
				return dispatch(modalitiesList())
					.then((mod) => {
						if(!_.isEmpty(mod.payload)){
							return dispatch(versionsList())
								.then((versions) => {
									if(!_.isEmpty(versions.payload)){
										dispatch(entitiesList())
										if(id){
											return dispatch(projectEdit(id))
												.then((data) => {
													if(!_.isEmpty(data.payload)){
														if(data.payload.modality_id === 2){
															dispatch(municipalitiesList(data.payload.agency.agenciable.state_id))
														}
														return dispatch(projectsComplete())
													}
												})
										}else {
											return dispatch(projectsComplete())
										}
									}else {
										return dispatch(projectsFail('Carga incompleta'));
									}
								})
						}else {
							return dispatch(projectsFail('Carga incompleta'));
						}
					})
			}else {
				return dispatch(projectsFail('Carga incompleta'));
			}
		})

}

/*Projects Edit*/
const projectEdit = (id) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/projects/projects/${id}?include[0]=agency.agenciable&include[1]=modality`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectEditData(json)),
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
};

/*Projects Save*/
export const projectSave = (values) => (dispatch) => {
	dispatch(projectsRequest());
	return dispatch(projectEditSave(values))
		.then((data) => {
			if(!_.isEmpty(data.payload)){
				if(values.id){
					return dispatch(projectsComplete())
				}
			}
		})
}

const projectEditSave = (values) => {
	console.log("-------------------------------------------------")
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				//dispatch(projectsRequest());

				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify(values)
				};

				return fetch(`${API2_URL}/projects/projects${values.id ? `/${values.id}?_method=PUT&include[0]=agency.agenciable&include[1]=modality`:'?include[0]=agency.agenciable&include[1]=modality'}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"El Proyecto se ha guardado correctamente", type: "success"}));
							if(_.isEmpty(values.id)){
								history.push('/proyectos/editar/datos/'+json.data.id);
							}
							return dispatch(projectEditData(json));
						},
						error => {
							dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}))
							return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
};

const projectEditData = (json) => {

	let response = {}

	if(json.data && json.data.modality && json.data.modality.agenciable_type === 'imm'){
		response = {
			...json.data,
			version_id: json.data.agency.version_id,
			state_id: json.data.agency.agenciable.state_id ? json.data.agency.agenciable.state_id:json.data.agency.agenciable.id,
			municipality_id: json.data.agency.municipality_id
		}
	}else {
		response = {
			...json.data,
			version_id: json.data.agency ? json.data.agency.version_id:undefined,
			state_id: json.data.agency ? json.data.agency.agenciable.id:undefined
		}
	}

	return {
		type: PROJECTS_EDIT,
		payload: response,
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

/*Goals*/
export const fetchProjectsGoalsEdit = (id = undefined) => (dispatch) => {
	dispatch(projectsRequest());
	dispatch(projectsClear());

	return dispatch(actorsList())
		.then((actors) => {
			if(!_.isEmpty(actors.payload)){
				return dispatch(conagoList())
					.then((conago) => {
						if(!_.isEmpty(conago.payload)){
							return dispatch(resourceConceptsList())
								.then((concepts) => {
									if(!_.isEmpty(concepts.payload)){
										return dispatch(projectEdit(id))
											.then((data) => {
												if(!_.isEmpty(data.payload)){
													return dispatch(goalsList(data.payload.modality_id,data.payload.agency.agenciable_id))
														.then((goals) => {
															if(!_.isEmpty(goals.payload)){
																return dispatch(projectGoals(id))
																	.then((goalsData) => {
																		if(!_.isEmpty(goalsData.payload)){
																			return dispatch(projectsComplete())
																		}
																	})
															}else {
																return dispatch(projectsFail('Carga incompleta'));
															}
														})

												}
											})
									}else {
										return dispatch(projectsFail('Carga incompleta'));
									}
								})
						}else {
							return dispatch(projectsFail('Carga incompleta'));
						}
					})
			}else {
				return dispatch(projectsFail('Carga incompleta'));
			}
		})
}

const projectGoals = (id) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/projects/projects/${id}/goals`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectGoalsEditData(json)),
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const projectGoalsSave = (id, values) => (dispatch) => {
	dispatch(projectsRequest());

	return dispatch(projectGoalsEditSave(id, values))
		.then((goals) => {
			if(!_.isEmpty(goals.payload)){
				return dispatch(projectsComplete())
			}
		})
}

const projectGoalsEditSave = (id, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			let goals = [];

			_.map(values, (data) => {
				goals.push({
					...data,
					activities: data.project_goal_activities
				})
			})

			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify({goals: goals})
			};

			return fetch(`${API2_URL}/projects/projects/${id}/goals`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"Las metas se han guardado correctamente", type: "success"}));
						return dispatch(projectGoalsEditData(json));
					},
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const projectGoalsEditData = (json) => {
	return {
		type: PROJECTS_GOALS,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

/*Expenses*/
export const fetchProjectsExpensesEdit = (id = undefined) => (dispatch) => {
	dispatch(projectsRequest());
	dispatch(projectsClear());

	return dispatch(conceptsList())
		.then((concepts) => {
			if(!_.isEmpty(concepts.payload)){
				return dispatch(projectExpensesEdit(id))
					.then((expenses) => {
						if(!_.isEmpty(expenses.payload)){
							return dispatch(projectsComplete())
						}
					})
			}
		})
}

const projectExpensesEdit = (id) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/projects/projects/${id}/expenses`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectExpensesEditData(json)),
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const projectsExpensesSave = (id, values) => (dispatch) => {
	dispatch(projectsRequest());

	return dispatch(projectExpensesEditSave(id, values))
		.then((expenses) => {
			if(!_.isEmpty(expenses.payload)){
				return dispatch(projectsComplete())
			}
		})
}

const projectExpensesEditSave = (id, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify({expenses: values})
			};

			return fetch(`${API2_URL}/projects/projects/${id}/expenses`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"Los gastos se han guardado correctamente", type: "success"}));
						return dispatch(projectExpensesEditData(json))
					},
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const projectExpensesEditData = (json) => {
	return {
		type: PROJECTS_EXPENSES,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

/*Employees*/
export const fetchProjectEmployeesEdit = (id = undefined) => (dispatch) => {
	dispatch(projectsRequest());
	dispatch(projectsClear());

	return dispatch(projectEmployeesEdit(id))
		.then((phases) => {
			if(!_.isEmpty(phases.payload)){
				return dispatch(projectsComplete())
			}
		})
}

const projectEmployeesEdit = (id) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/projects/projects/${id}/employees`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectEmployeesData(json)),
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

/*export const projectEmployeeEditSave = (id, values) => (dispatch) => {
	dispatch(projectsRequest());

	return dispatch(projectEmployeeSave(id, values))
		.then((phases) => {
			if(!_.isEmpty(phases.payload)){
				return dispatch(projectsComplete())
			}
		})
}*/

export const projectEmployeeEditSave = (id, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectEditRequest());
			let body = {
				period_start: values.period_start,
				period_end: values.period_end,
				status_id: _.toNumber(values.status_id)
			}

			let param = '';

			if(values.type === 'agency'){
				param = 'agency';
				body = {
					...body,
					user_id: values.user_id,
					role_id: values.role_id
				}
			}else {
				param = 'project-goal-agency';
				body = {
					...body,
					job_function: values.job_function,
					rfc_invoices: values.rfc_invoices,
					wage: values.wage,
				}
			}

			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify(body)
			};

			return fetch(`${API2_URL}/projects/projects/${id}/${param}/employees${values.id ? `/${values.id}?_method=PUT`:''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"Los datos se han guardado correctamente", type: "success"}));
						return dispatch(projectEmployeesEditData(json));
						//return dispatch(projectsComplete())
					},
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}))
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
};

export const projectEmployeeDelete = (id, employeeId) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectsRequest());

			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'delete'
			};

			return fetch(`${API2_URL}/projects/projects/${id}/project-goal-agency/employees/${employeeId}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"El empleado se ah eliminado correctamente", type: "success"}));
						//return dispatch(projectEmployeesEditData(json));
						//return dispatch(projectsComplete())
						dispatch(fetchProjectEmployeesEdit(id));
					},
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}))
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
};

const projectEmployeesData = (json) => {
	let employees = [];

	if(json.data && json.data.project_goals){
		_.map(json.data.project_goals, (item) => {
			if(item.project_goal_agencies){
				_.map(item.project_goal_agencies, (goal) => {
					if(goal.employees){
						_.map(goal.employees, (emp) => {
							let data = {};

							_.mapKeys(emp,(i, k) => {
								data = {
									...data,
									[k]:i ? i:undefined
								}
							})

							employees.push({
								...data,
								agency_id: goal.agency_id,
								project_goal_id: goal.project_goal_id,
								agency: {...goal.agency},
								project_goal:{name: item.name, code: item.code}
							});
						})
					}
				})
			}
		})
	}

	return {
		type: PROJECTS_EMPLOYEES,
		payload: {
			...json.data,
			employees
		},
		roles: json.roles,
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

const projectEmployeesEditData = (json) => {
	return {
		type: PROJECTS_EMPLOYEES_EDIT,
		isFetching: false,
		payload: {
			...json.data,
			action: 'close'
		},
		timestamp: Date.now()
	}
};

/*Phases*/
export const fetchProjectPhasesGroupsEdit = (id = undefined) => (dispatch) => {
	dispatch(projectsRequest());
	dispatch(projectsClear());

	return dispatch(projectPhasesGroupsEdit(id))
		.then((phases) => {
			if(!_.isEmpty(phases.payload)){
				return dispatch(projectsComplete())
			}
		})
}

const projectPhasesGroupsEdit = (id) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/projects/projects/${id}/version-phases-groups`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectPhasesGroupsData(json)),
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const projectPhaseSave = (id, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectEditRequest());
			let body = {
				star_date: values.start_date,
				end_date: !_.isEmpty(values.end_date) ? values.end_date:null
			}
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify(body)
			};

			return fetch(`${API2_URL}/projects/projects/${id}/version-phases-groups/${values.id}?_method=PUT`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"Los datos se han guardado correctamente", type: "success"}));
						//return dispatch(projectPhasesGroupsEditData(json));
						return dispatch(projectPhasesGroupsEditData())
					},
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}))
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
};

export const projectPhaseDelete = (id, phaseId) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectsRequest());
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'delete'
			};

			return fetch(`${API2_URL}/projects/projects/${id}/version-phases-groups/${phaseId}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"El proceso se elimino correctamente", type: "success"}));
						//return dispatch(projectPhasesGroupsEditData(json));
						return dispatch(fetchProjectPhasesGroupsEdit(id))
					},
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}))
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
};

const projectPhasesGroupsData = (json) => {
	return {
		type: PROJECTS_PHASES_GROUPS,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

const projectPhasesGroupsEditData = () => {
	return {
		type: PROJECTS_PHASES_GROUPS_EDIT,
		isFetching: false,
		payload: {action: 'close'},
		timestamp: Date.now()
	}
};

export const fetchProjectCommission = (id) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectsRequest());
			dispatch(projectsClear());

			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/projects/projects/${id}/commissions`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectCommissionData(json)),
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const projectCommissionData = (json) => {
	let answers = [];

	if(!_.isEmpty(json.data) && !_.isEmpty(json.data.comissions_review) && !_.isEmpty(json.data.comissions_review.survey_version_phase) && !_.isEmpty(json.data.comissions_review.survey_version_phase.survey)){
		_.map(json.data.comissions_review.survey_version_phase.survey.children_questions,(q) => {
			if(q.type === 'group'){
				_.map(q.children_questions,(item) => {
					if(item.answer){
						//let answer = _.find(q.answers,{question_id: q.id});
						answers.push({spvpu_id: item.answer.spvpu_id, question_id: item.answer.question_id, answer_number: item.answer.answer_number, answer_text: item.answer.answer_text})
					}
				})
			}else {
				if(q.answer){
					//let answer = _.find(q.answers,{question_id: q.id});
					answers.push({spvpu_id: q.answer.spvpu_id, question_id: q.answer.question_id, answer_number: q.answer.answer_number, answer_text: q.answer.answer_text})
				}
			}
		})
	}

	return {
		type: PROJECTS_COMMISSIONS,
		isFetching: false,
		payload: {
			...json.data,
			answers
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

export const projectsFolios = (mod) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectsRequest());
			if(mod === 'modalidad-ii'){
				dispatch(entitiesList())
			}
			dispatch(projectsClear());

			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/projects/codes/${mod}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectsFoliosData(json)),
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const projectsFoliosAssign = (mod) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectsRequest());

			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post'
			};

			return fetch(`${API2_URL}/projects/codes/${mod}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"Éxito", content: json.message ? json.message:'Folios asignados correctamente', type: "success"}))
						return dispatch(projectsFoliosData(json))
					},
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}
export const aquitarFoliosManual = (id,notas,version,modality) => (dispatch) => {
	let body={
		id:id,
		version:version,
		modality:modality,
		notas:notas
	}
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectsRequest());
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify(body)
			};
            console.log('quitar de folios manual');
		    var url=`${API2_URL}/projects/quitarFolio`;
		    return fetch(url, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"Éxito", content: json.message ? json.message:'Folios asignados correctamente', type: "success"}))
						return dispatch(projectsFoliosData(json))
					},
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const asignacionFoliosManual = (id,version,modality) => (dispatch) => {
let body={
	id:id,
	version:version,
	modality:modality
}

	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectsRequest());
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify(body)
			};
            console.log('asignacion de folios manual');
			const url = new URL(`${API2_URL}/projects/storeFolios`);
		    return fetch(url, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"Éxito", content: json.message ? json.message:'Folios asignados correctamente', type: "success"}))
						return dispatch(projectsFoliosData(json))
					},
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}
const projectsFoliosData = (json) => {
	return {
		type: PROJECTS_FOLIOS,
		isFetching: false,
		payload: json.data,
		codes_assigned: json.codes_assigned,
		version: json.version,
		permissions: json.permissions,
		modality:json.modality,
		timestamp: Date.now()
	}
}

/*Fetching*/
const projectEditRequest = () => {
	return {
		type: PROJECTS_EDIT_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
};

/*Fetching*/
const projectsRequest = () => {
	return {
		type: PROJECTS_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
};

/*Complete*/
const projectsComplete = () => {
	return {
		type: PROJECTS_COMPLETE,
		isFetching: false,
		timestamp: Date.now()
	}
};

/*Clear*/
const projectsClear = () => {
	return {
		type: PROJECTS_CLEAR,
		payload:{
			project:{},
			goals:[],
			expenses: [],
			phases_groups: [],
			employees:{},
			roles: [],
			folios: [],
			edit: {
				isFetching: false
			},
			codes_assigned: false,
			version: {}
		},
		timestamp: Date.now()
	}
};

/*Fails*/
const projectsFail = (error) => {
	return {
		type: PROJECTS_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
};


// WEBPACK FOOTER //
// ./src/actions/projects.js